import React from 'react';

/**
 * Accessible on/off switch.
 * @param {{checked: boolean, onChange: (v: boolean) => void, label: string, disabled?: boolean, testId?: string}} props
 */
export default function Toggle({ checked, onChange, label, disabled = false, testId }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      data-testid={testId}
      className={`relative h-5 w-9 shrink-0 rounded-full transition disabled:cursor-not-allowed disabled:opacity-40 ${checked ? 'bg-civix-purple' : 'bg-white/20'}`}
    >
      <span className={`absolute top-0.5 h-4 w-4 rounded-full bg-white shadow transition-all ${checked ? 'left-[18px]' : 'left-0.5'}`} />
    </button>
  );
}
